<div class="sidebar-context px-3 position-relative">

  <!-- Label -->
  <!-- <p class="text-white text-uppercase mb-2 d-block fw-light text-xxs">Active Context</p> -->

  <!-- SELECTED ITEM CARD -->
  <div
    class="sidebar-context-card context-card border rounded-3 p-2 bg-collapsable-btn cursor-pointer"
    @click="toggle"
  >
    <div class="sidebar-context-card-inner d-flex align-items-center justify-content-between">
      <div class="sidebar-context-copy">
        <p class="mb-0 text-white fw-bold text-xs mb-1">{{ main_label }}</p>
        <p class="mb-0 text-white-50 text-xxs text-uppercase">{{ sub_label }}</p>
      </div>
      <i class="sidebar-context-toggle" :class="open ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
    </div>
  </div>

  <!-- DROPDOWN PANEL -->
  <div
    v-if="open"
    class="sidebar-context-dropdown context-dropdown position-absolute bg-collapsable-btn border rounded-3 p-3 dropdown-panel w-80 justify-content-center align-items-center mx-3"
  >

    <!-- OPTIONAL TOP SECTION (slot) -->
    <slot name="top"></slot>

    <!-- LIST SCROLL SECTION -->
    <div class="dropdown-scroll overflow-auto">

      <div
        v-for="item in items"
        :key="item.id"
        class="sidebar-context-option py-1 d-flex justify-content-between align-items-center fw-semibold text-xs"
        :class="{
          'disabled-tile': !isLive(item),
          'live-tile': isLive(item)
        }"
        :style="{ cursor: isLive(item) ? 'pointer' : 'not-allowed' }"
        @click="isLive(item) ? select(item) : null"
      >

        <!-- Item Label -->
        <div class="sidebar-context-option-copy d-flex align-items-center gap-2">
          <!-- ICON (visible only when sidebar is collapsed) -->
          <i 
            v-if="$root.sidebar_collapsed"
            :class="item.icon"
            class="dropdown-item-icon"
          ></i>

          <!-- LABEL -->
          <small
            class="d-block fw-semibold mb-0"
            :class="isActive(item) ? 'text-warning' : 'text-white'"
          >
            {{ formatLabel(item) }}
          </small>

        </div>


        <!-- Active Dot -->
        <span v-if="isActive(item)" class="active-dot"></span>
      </div>

    </div>
  </div>

</div>
